import LanguageSwitcher from './language-switcher';

export default LanguageSwitcher;